module.exports = __webpack_public_path__ + "static/6305-woodrose-26-500e38edd4a1fe2c994d5541641d0c40.jpg";